import { Alert, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import format from 'date-fns/format';
import { TaskStatuses } from '../../../api/types';
import { useInsuranceVerificationDataFetch } from './hooks/useInsuranceVerificationDataFetch';
import { Task } from '@trnsact/trnsact-shared-types';
import { ApplicantInfo, DealerInfo, LenderInfo, InsuranceCoverageRequirements, InsuranceCertificateForm } from './ui';

import { InsuranceCertificateFormValues } from './types';
import { useInsuranceVerificationSubmit } from './hooks/useInsuranceVerificationSubmit';
import { LoadingSkeleton } from './ui/LoadingSkeleton';

interface Props {
  task: Task;
  publicAccount: any;
  refetchTask: any;
};

export const InsuranceVerificationPage = ({
  task,
  publicAccount,
  refetchTask,
}: Props) => {

  const classes = useStyles();

  const {
    lenderProfile,
    creditSubmission,
    vendorOpportunity,
    creditApplication,
    financeProgram,
    isLoading: isInsuranceVerificationDataLoading
  } = useInsuranceVerificationDataFetch(task);

  const { submit, isLoading: isSubmitLoading } = useInsuranceVerificationSubmit();

  const onSubmit = async (values: InsuranceCertificateFormValues) => await submit(task, values, refetchTask);

  const isLoading = isInsuranceVerificationDataLoading || isSubmitLoading;

  return <>
    <Typography variant='h3' className={classes.header}>Insurance Request</Typography>
    {isLoading
      ? <LoadingSkeleton />
      : <>
        <Box className={classes.requestedBox}>
          <Typography fontWeight={500}>Requested By</Typography>
          <Typography fontWeight={500}>Requested Date: {format(new Date(task.createdDateTime!), 'MM/dd/yyyy')}</Typography>
        </Box>

        <LenderInfo
          lenderProfile={lenderProfile!}
          creditSubmission={creditSubmission!}
          commonClasses={classes}
        />

        <DealerInfo
          task={task}
          publicAccount={publicAccount}
          commonClasses={classes}
        />

        <ApplicantInfo
          vendorOpportunity={vendorOpportunity!}
          creditApplication={creditApplication!}
          commonClasses={classes}
        />

        <InsuranceCoverageRequirements financeProgram={financeProgram} commonClasses={classes} />

        {task.status === TaskStatuses.Complete
          ? <Alert severity="success">Insurance Certificate has been successfully uploaded!</Alert>
          : <InsuranceCertificateForm commonClasses={classes} onSubmit={onSubmit} />}
      </>
    }
  </>
};

const useStyles = makeStyles(() => {
  return {
    header: {
      '&.MuiTypography-root': {
        fontWeight: 500,
        fontSize: 24,
        textAlign: 'center',
        marginBottom: 32,
      },
    },
    subHeader: {
      '&.MuiTypography-root': {
        fontWeight: 500,
        fontSize: 16,
        margin: '32px 0 12px',
      },
    },
    requestedBox: {
      margin: '8px 0',
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#E8EAF6',
    },
    infoRow: {
      display: 'Grid',
      gridTemplateColumns: '1fr 2fr'
    },
    lenderDealerContactInfoBlock: {
      display: 'flex',
    },
    infoRows: {
      flex: 1
    },
    logoContainer: {
      paddingLeft: 8,
      flexBasis: '25%'
    },
  };
});
